import { clsx } from 'clsx';
import React from 'react';
import classes from './InputLabel.module.css.js';
import { BoxWithFallback } from './BoxWithFallback.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function InputLabel({
  children,
  disabled,
  htmlFor,
  id,
  required,
  requiredText,
  requiredIndicator,
  visuallyHidden,
  sx,
  as = 'label',
  className,
  ...props
}) {
  return (
    /*#__PURE__*/
    // @ts-ignore weird typing issue with union for `as` prop
    React.createElement(BoxWithFallback, _extends({
      as: as,
      sx: sx,
      "data-control-disabled": disabled ? '' : undefined,
      "data-visually-hidden": visuallyHidden ? '' : undefined,
      htmlFor: htmlFor,
      id: id,
      className: clsx(className, classes.Label)
    }, props), required || requiredText ? /*#__PURE__*/React.createElement("span", {
      className: classes.RequiredText
    }, /*#__PURE__*/React.createElement("span", null, children), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": requiredIndicator ? undefined : true
    }, requiredText !== null && requiredText !== undefined ? requiredText : '*')) : children)
  );
}
InputLabel.displayName = "InputLabel";

export { InputLabel };
